import script from "./ReadModelFieldRows.vue?vue&type=script&setup=true&lang=js"
export * from "./ReadModelFieldRows.vue?vue&type=script&setup=true&lang=js"

import "./ReadModelFieldRows.vue?vue&type=style&index=0&id=4b9703e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b9703e2"]])

export default __exports__